export const ADMIN = "ADMINISTRATOR";
export const SALES_MANAGER = "SALESMANAGER";
export const CONTENT_DIRECTOR ="CONTENTDIRECTOR" ;
export const CONTENT_COORDINATOR = "CONTENTCOORDINATOR";
export const CONTENT_EDITOR = "CONTENTEDITOR";
